__turbopack_context__.v({
  "body": "myM93q_body",
  "card": "myM93q_card",
  "heading": "myM93q_heading",
});
